import { useQuery } from "@tanstack/react-query";
import { API_URL } from "@/config/constants";

interface UNEvent {
  un_day: string;
  date: string;
  action_before: number;
  image: string;
  description: string;
}

interface UNEventsResponse {
  data: UNEvent[];
}

interface Opportunity {
  id: string;
  name: string;
  subtype: string;
  beneficiary_types: string[];
  is_active: boolean;
  created_by: string | null;
  approved_by: string | null;
  status: string;
  created_at: string;
  updated_at: string;
  community_need: string;
  volunteer_support: string;
  impact: string;
  relevant_un_day: string[];
  type: string;
  sdg_alignment: string[];
}

export interface OpportunitiesResponse {
  data: Opportunity[];
}

export const useUNEvents = (token: string, month: string) => {
  return useQuery<UNEventsResponse>({
    queryKey: ["un-events", month],
    queryFn: async () => {
      const response = await fetch(`${import.meta.env.VITE_CC_API_URL}/v1/campaign/un-events/list?month=${month}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch UN events");
      }
      return response.json();
    },
    enabled: !!token,
  });
};

export const useUNDayOpportunities = (token: string, day: string | null) => {
  return useQuery<OpportunitiesResponse>({
    queryKey: ["un-events", "opportunities", day],
    queryFn: async () => {
      if (!day) throw new Error("No day selected");
      const response = await fetch(`${import.meta.env.VITE_CC_API_URL}/v1/campaign/un-events/opportunities?day=${encodeURIComponent(day)}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch opportunities");
      }
      return response.json();
    },
    enabled: !!day && !!token,
  });
};
